import { ComponentRef } from '@wix/public-editor-platform-interfaces';
import { BaseSDKShape } from '../BaseSDKShape';
import { PlatformSDKShape } from '../PlatformSDKShape';
import {
  BindingTarget,
  IBindingsProvider,
  IDataBindingItem,
} from '../bindings/types';
import { BindingConnectionItem } from '../bindings';

class BindingsProvider implements IBindingsProvider {
  constructor(
    private privateAPI: any,
    private compRef: ComponentRef,
    private dataItemTarget: BindingTarget,
    public name: string,
  ) {}

  public select() {
    return this.privateAPI.bindings.openDataBindingPanel(
      this.dataItemTarget.id,
    );
  }

  public createBinding(data: IDataBindingItem) {
    const created = this.privateAPI.bindings.create(this.compRef, {
      dataItemId: this.dataItemTarget.id,
      bindingItemType: 'dataBinding',
      ...data,
    });

    if (!created) {
      return null;
    }

    return new BindingConnectionItem(
      this.privateAPI,
      this.compRef,
      this.dataItemTarget.id,
      JSON.stringify(data),
    );
  }
}
export class BindingsProvidersSDKShape extends BaseSDKShape {
  public async list(bindingTarget: BindingTarget) {
    const privateAPI = await this.getPlatformPrivateAPI();
    const compRefs: ComponentRef[] =
      await privateAPI.components.getSelectedComponents();
    if (compRefs.length !== 1) {
      return [];
    }
    const [compRef] = compRefs;
    if (!(await privateAPI.bindings.canCreateBindingsProvider(compRef))) {
      return [];
    }

    return [
      new BindingsProvider(privateAPI, compRef!, bindingTarget, 'dataBinding'),
    ];
  }
}

export default new PlatformSDKShape(BindingsProvidersSDKShape)
  .withPublicMethod('list')
  .build();
